export default "__VITE_ASSET__f8232008__"